'use strict';
const angular = require('angular');

export class contactWidgetComponent {

  constructor($uibModal, Auth) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.Auth = Auth;
  }

  openFeedbackModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'feedbackForm',
      resolve: {}
    });

    modalInstance.result.then(
      function (feedback) {

        that.UserService.sendFeedback({ id: that.Auth.getCurrentUserSync()._id }, {
          feedback: feedback
        }, () => {
          that.dialogs.notify("Your feedback has been sent","Your feedback has been sent.<br/>Thank you very much!");
        });
      },
      function () {
      }
    );
  }

  $onInit() {
  }
}

export default angular.module('conduuApp.contactWidgetComponent', [])
  .component('contactWidget', {
    template: `<a ng-click="$ctrl.openFeedbackModal()" class="btn btn-more btn-feedback-form">
                <i ng-if="$ctrl.icon" class="fa {{$ctrl.icon}}"></i> 
                {{$ctrl.title || 'Feedback'}}</a>`,
    bindings: {
      icon: '@',
      title: '@'
    },
    controller: contactWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/contact-widget/contact-widget.component.js